<div class="new-folder" [formGroup]="formGroup">
  <h2 mat-dialog-title>Create new folder</h2>
  <mat-dialog-content class="new-folder__form-fields">
    <mat-form-field>
      <input matInput placeholder="Folder name" formControlName="name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Choose Company</mat-label>
      <mat-select formControlName="companyId">
        @for (company of companies$ | async; track company.id) {
          <mat-option [value]="company.id">{{ company.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="clear()">Clear</button>
    <button mat-flat-button (click)="create()">Create</button>
  </mat-dialog-actions>
</div>
